// extracted by mini-css-extract-plugin
module.exports = {"className":"textLegalS_className__3wL71"};